import { render, staticRenderFns } from "./Relations.vue?vue&type=template&id=7583a98a&scoped=true"
import script from "./Relations.vue?vue&type=script&setup=true&lang=js"
export * from "./Relations.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7583a98a",
  null
  
)

export default component.exports